import React, { useEffect, useRef } from "react";

const Captcha = ({ onCaptchaChange, disabled }) => {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  
  // Store the callback in a mutable ref so the render effect does not run repeatedly
  const callbackRef = useRef(onCaptchaChange);
  
  useEffect(() => {
    callbackRef.current = onCaptchaChange;
  }, [onCaptchaChange]);

  useEffect(() => {
    const checkAndRender = () => {
      if (window.grecaptcha && window.grecaptcha.render && containerRef.current) {
        try {
          const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
          widgetIdRef.current = window.grecaptcha.render(containerRef.current, {
            sitekey: siteKey,
            theme: "light",
            callback: (token) => {
              callbackRef.current(token, "g-recaptcha");
            },
            "expired-callback": () => {
              callbackRef.current("", "");
            },
            "error-callback": () => {
              callbackRef.current("", "");
            }
          });
        } catch (e) {
          console.error("reCAPTCHA render error:", e);
        }
      }
    };

    if (window.grecaptcha && window.grecaptcha.render) {
      checkAndRender();
    } else {
      const interval = setInterval(() => {
        if (window.grecaptcha && window.grecaptcha.render) {
          checkAndRender();
          clearInterval(interval);
        }
      }, 500);
      return () => clearInterval(interval);
    }

    return () => {
      if (window.grecaptcha && window.grecaptcha.reset && widgetIdRef.current !== null) {
        try {
          window.grecaptcha.reset(widgetIdRef.current);
        } catch (e) {
          // ignore
        }
      }
    };
  }, []); // Run only once on mount

  return (
    <div className="flex flex-col gap-2 mt-4 p-4 rounded-xl border border-gray-200/50 bg-gray-50/50 backdrop-blur-sm items-center">
      <label className="text-xs font-semibold uppercase tracking-wider text-gray-500 self-start">
        Security Check
      </label>
      <div ref={containerRef} className="my-1"></div>
    </div>
  );
};

export default Captcha;
